import { call, put, takeLatest } from 'redux-saga/effects';
import HeroPllOptionsAPI from 'api-services/HeroPillOptionsApi';
import { isSuccessResponse } from 'api-services/types/guards';
import { FETCH_PILL_OPTIONS_NAME, FETCH_PILL_OPTIONS_FORM, FETCH_PILL_OPTIONS_STRENGTH, FETCH_PILL_OPTIONS_STUB } from './actionTypes';
import { fetchPillOptionsStubDone, fetchPillOptionsStubError, fetchPillOptionsNameDone, fetchPillOptionsNameError, fetchPillOptionsFormDone, fetchPillOptionsFormError, fetchPillOptionsStrengthDone, fetchPillOptionsStrengthError } from './actionCreators';
import { checkUserHelper } from '../utils/helperSagas';
import { logout } from '../auth/actionCreators';
export function* getPillsOptionsStub(constAccessParams, action) {
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroPllOptionsAPI.getPillOptionsStub, newAccessParams, action.data);
    if (isSuccessResponse(result)) {
        yield put(fetchPillOptionsStubDone(result.data.results.map((r) => r.drug_name)));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(fetchPillOptionsStubError(result.msg));
    }
}
export function* getPillsOptionsName(constAccessParams, action) {
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroPllOptionsAPI.getPillOptionsName, newAccessParams, action.data);
    if (isSuccessResponse(result)) {
        yield put(fetchPillOptionsNameDone(result.data));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(fetchPillOptionsNameError(result.msg));
    }
}
export function* getPillsOptionsForm(constAccessParams, action) {
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroPllOptionsAPI.getPillOptionsForm, newAccessParams, action.data);
    if (isSuccessResponse(result)) {
        yield put(fetchPillOptionsFormDone(result.data.form.flat()));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(fetchPillOptionsFormError(result.msg));
    }
}
export function* getPillsOptionsStrength(constAccessParams, action) {
    const newAccessParams = yield call(checkUserHelper, constAccessParams);
    const result = yield call(HeroPllOptionsAPI.getPillOptionsStrength, newAccessParams, action.data);
    if (isSuccessResponse(result)) {
        yield put(fetchPillOptionsStrengthDone(result.data));
    }
    else if (result.statusCode === 4) {
        yield put(logout());
    }
    else {
        yield put(fetchPillOptionsStrengthError(result.msg));
    }
}
export function* watchFetchPillOptionsStubCalls(constAccessParams) {
    yield takeLatest(FETCH_PILL_OPTIONS_STUB, getPillsOptionsStub, constAccessParams);
}
export function* watchFetchPillOptionsNameCalls(constAccessParams) {
    yield takeLatest(FETCH_PILL_OPTIONS_NAME, getPillsOptionsName, constAccessParams);
}
export function* watchFetchPillOptionsFormCalls(constAccessParams) {
    yield takeLatest(FETCH_PILL_OPTIONS_FORM, getPillsOptionsForm, constAccessParams);
}
export function* watchFetchPillOptionsStrengthCalls(constAccessParams) {
    yield takeLatest(FETCH_PILL_OPTIONS_STRENGTH, getPillsOptionsStrength, constAccessParams);
}
//# sourceMappingURL=saga.js.map